import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {NestApiProvider} from "../../nest-api";
import {ResponsePreviewDto, ResponseShiftPreviewDto} from "../dto/report-preview.dto";

@Injectable()
export class ReportPreviewApi {
  private service: string = '';
  // private model: string = '';

  constructor(
    public nestApiProvider: NestApiProvider) {
  }

  preview(dataUrl: any, dataBody: any, apiUrl: string): Observable<ResponsePreviewDto> {
    const method: string = 'POST';
    const model : string = apiUrl
    const func: string = '';
    const params: any = dataBody;
    const urlParams: any = dataUrl;
    const body: any = {};
    const timeout: number = (5 * 60) * 1000;
    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePreviewDto>(method, url, params, urlParams, body, null, timeout);
  }

  previewChart(dataUrl: any, dataBody: any, apiUrl: string): Observable<any> {
    const method: string = 'POST';
    const model : string = apiUrl
    const func: string = '';
    const params: any = dataBody;
    const urlParams: any = dataUrl;
    const body: any = {};
    const timeout: number = (5 * 60) * 1000;
    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body, null, timeout);
  }

  previewShift(dataUrl: any, dataBody: any, apiUrl: string): Observable<ResponseShiftPreviewDto> {
    const method: string = 'POST';
    const model : string = apiUrl
    const func: string = '';
    const params: any = dataBody;
    const urlParams: any = dataUrl;
    const body: any = {};
    const timeout: number = (5 * 60) * 1000;
    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseShiftPreviewDto>(method, url, params, urlParams, body, null, timeout);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/report-preview.api.ts